/*global ga*/
/*eslint no-console: 0*/

export const Ga = {
    bind: (el, binding) => {

        this.send = (modifier, binding) => {
            let gaParams = { hitType: 'event' }
            for (let [key, value] of Object.entries(binding.value)) {
                gaParams['event' + key] = value
            }

            if (typeof ga === 'function') {
                ga('send', gaParams)
            } else {
                let messages = []
                for (let [key, value] of Object.entries(binding.value)) {
                    messages.push(`event${key}: ${value}`)
                }
                console.warn(`Произошло событие (${messages.join(', ')}), но оно не отправлено т.к. GA не подключен к сайту. Сработал модификатор: ${modifier}`)
            }
        }

        if ('load' in binding.modifiers) {
            this.send('load', binding)
        }
    },

    inserted: (el, binding) => {
        if ('click' in binding.modifiers) {
            el.addEventListener('click', () => this.send('click', binding))
        }
    },

    update: (el, binding, vnode, oldVnode) => {
        if ('show' in binding.modifiers) {
            if (vnode.data.style.display != oldVnode.data.style.display && oldVnode.data.style.display == 'none') {
                this.send('show', binding)
            }
        }

        if ('change' in binding.modifiers) {
            this.send('change', binding)
        }
    }
}